import { LitElement, html, css } from 'lit';
import "./header-mobile.css"

export class HeaderMobile extends LitElement {

    static styles = css`
    *,
    ::before,
    ::after {
        box-sizing: border-box;
        border-style: solid;
        border-width: 0;
    }
    a{line-height:0;}
    
    :host{
        position:fixed;
        display:flex;
        top: 0;
        left:0;
        right:0;
        z-index:1000;
        transition : all 250ms ease ;
    }

    .--light{
        --header-mobile-light-color-button : white;
    }

    header{
        display:flex;
        justify-content:center;
        width:100%;
        background:var(--header-mobile-background, none);
    }

    .wrapper{
        display:flex;
        width: calc(100% - 80px);
        flex-direction : column;
        justify-content: space-between;
    }

    .logo,
    .button {
        display:flex;
        align-items:center;
        justify-content:center;
        cursor : pointer;
 
    }
    .logo img{
        height:30px;    
    }


   

    img{
     height:60px;
    }

    .button span{
        text-align: right;
        font-family : var(--font-02);
        font-size: var(--font-size-default);
        color : var(--header-mobile-close-color-button);
    }

    .icon{
        width: 32px;
        height: 32px;
        margin-left : 10px;
        display: flex;
        align-items:center;
        justify-content :center;
    }

    .--light .button:hover .icon svg line,
    .icon svg line{
        stroke : var(--header-mobile-close-color-button);
        transition: stroke 250ms ease;
    }

    .bottom{
        position: fixed;
        top: 0;
        left:0;
        right: 0;
        bottom:0;
        background-color: var(--header-mobile-background-open);
        color: white;
        transform : translate3d(0,0,0);
        transition: all 500ms ease;
        overflow:auto;
    }
  

    .top{
        display:flex;
        justify-content:space-between;
        height:60px; 
        z-index:1;
    }

    .--close .bottom{
        transform : translate3d(0,-100%,0);
    }

    .--open .button{
    }

    .button:hover span,
    .--light .button span,
    .--open .button span{
        color: var(--header-mobile-open-color-button);
    }

    .--open.--light .button:hover .icon svg line{
        stroke: var(--marron-clair);
    }

    .button:hover .icon svg line,
    .--light .button .icon svg line,
    .--open .button .icon svg line{
        stroke: var( --header-mobile-open-color-button) ;
    }
   
    `
    static properties = {
        isLight: { type: Boolean },
        isOpen: { type: Boolean },
        logosrc: { type: String },
        logolightsrc: { type: String },
        logolink: { type: String },
        startTheme: { type: String },
        logoToDisplay: { type: String }
    }

    constructor() {
        super();
        this.isOpen = false;
        this.isLight = true

        this.animationMenu = []
        this.animateKeyframes = [
            {
                opacity: 0,
                transform: "translateY(30px)"
            },
            {
                opacity: 1,
                transform: "translateY(0px)"
            }
        ]
    }

    firstUpdated() {
        // this.querySelectorAll('a').forEach(lien =>
        //     lien.onclick = () => {
        //         this.isOpen = false
        //     })
        this.dispatchEvent(new CustomEvent("load"));

    }

    willUpdate(params) {
        // ISOPEN TRUE || FALSE
        if (params.has('isOpen')) {
            if (this.isOpen === true) {
                this.setIsLight(true)
                this.dispatchEvent(new CustomEvent("open"));
                this.querySelectorAll('nav li, .title-xs, social-item').forEach((el, i) => {
                    this.animeOnEnter(el, 75 * i)
                })
                document.body.style.overflow = "hidden";
            } else {
                this.dispatchEvent(new CustomEvent("close"))
                this.animationMenu.forEach(el => { el.effect.updateTiming({ direction: 'reverse' }); })
                document.body.style.overflow = "auto";
                this.setIsLight(false)
            }
        }
        if (params.has('isLight')) {
            this.isLight ? this.logoToDisplay = this.logolightsrc : this.logoToDisplay = this.logosrc
        }
    }

    disconnectedCallback() {
        document.removeEventListener("scroll", () => this.isSticky())
    }

    setIsLight(val) {
        this.isLight = val
    }

    toggleMenu() {
        this.isOpen = !this.isOpen;
    }

    toggleLogoHover() {
        this.logoToDisplay = this.isLight ? this.logolightsrc : this.logosrc
    }


    /**
     * 
     * @param {HTMlElement} element 
     * @param {Number} delay 
     */
    animeOnEnter(element, delay) {
        element.style.display = "block";
        element.style.opacity = this.animateKeyframes[0].opacity;
        element.style.transform = this.animateKeyframes[0].transform;
        let newDelay = 300 + delay;
        let anim = element.animate(this.animateKeyframes,
            { duration: 500, delay: newDelay, fill: "forwards", easing: "ease" })
        this.animationMenu.push(anim)

    }

    renderButtonClose() {
        return html`
        <svg xmlns="http://www.w3.org/2000/svg" width="14.142" height="14.142" viewBox="0 0 14.142 14.142">
            <g data-name="Groupe 823" transform="translate(-1321.429 -32.929)">
                <line id="Ligne_2" data-name="Ligne 2" x2="18" transform="translate(1322.136 46.364) rotate(-45)" fill="none"
                    stroke="#fff" stroke-width="2" />
                <line id="Ligne_3" data-name="Ligne 3" x2="18" transform="translate(1322.136 33.636) rotate(45)" fill="none"
                    stroke="#fff" stroke-width="2" />
            </g>
        </svg>
    `
    }

    renderButtonBurger() {
        return html`
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="15" viewBox="0 0 19 15">
            <g id="Groupe_116" data-name="Groupe 116" transform="translate(-339.943 -25)">
                <line id="Ligne_13" data-name="Ligne 13" x1="19" transform="translate(339.943 25.5)" fill="none"
                    stroke="#1c2c52" stroke-width="1" />
                <line id="Ligne_14" data-name="Ligne 14" x1="19" transform="translate(339.943 32.5)" fill="none"
                    stroke="#1c2c52" stroke-width="1" />
                <line id="Ligne_15" data-name="Ligne 15" x1="19" transform="translate(347.943 39.5)" fill="none"
                    stroke="#1c2c52" stroke-width="1" />
            </g>
        </svg>`
    }

    render() {
        return html`
        <header class="${!this.isOpen ? '--close' : '--open'} ${this.isLight ? '--light' : '--dark'}">
            <div class="wrapper">
                <div class="top">
                    <div class="logo">
                        <a href="${this.logolink}" target="_parent">
                            <img src="${this.logoToDisplay}" alt="logo" height="100%" width="100%" />
                        </a>
                    </div>
                    <div class="button" @click=${this.toggleMenu}>
                        <!-- <span> ${!this.isOpen ? "menu" : "fermer"}</span> -->
                        <div class="icon">
                            ${!this.isOpen ? this.renderButtonBurger() : this.renderButtonClose()}
                        </div>
                    </div>
                </div>
                <div class="bottom ">
                    <slot class="slot" name="content">
                    </slot>
                </div>
            </div>
        </header>
        `
    }


}


customElements.define('header-mobile', HeaderMobile)
